import React from 'react'
import { NavLink } from 'react-router-dom'

const Price = () => {
    return (
        <section>
            <div className="container">
                <div className="text-center mb-5">
                    <div className="medium font__size--14 text__14-1024 btn__tag mb-3">Membership</div>

                    <h2 className="medium font__size--40 text__40-1024 text__40-md text__40-mm">Your dream body <br className='d-none d-md-block' /> starts right here...</h2>
                </div>

                <div className="row justify-content-center">
                    <div className="col-md-6 mb-4 mb-lg-0 col-lg-4">
                        <div className="wrapper__price-list">
                            <h4 className="medium font__size--40 text__40-1024 text__40-md text__40-mm mb-3">EGP750<sub className="medium font__size--16 text__16-1024 color__gray-2">/<span style={{ textDecoration: 'line-through' }}>1500</span></sub></h4>
                            <p className="medium font__size--20 text__20-1024 color__purple mb-0">SILVER</p>

                            <ul className="list__data-detail medium font__size--18 text__18-1024 my-4">
                                <li>
                                <div className="d-flex align-items-start">
  <img src="./../images/asa.png" className='object-fit-content' alt="" />
  <span className="ml-2">
    <span
      style={{
        backgroundColor: '#FFD700',   // gold highlight
        color: '#000',                 // black text for contrast
        fontWeight: '600',             // bold
        padding: '2px 6px',            // some spacing around the word
        borderRadius: '4px'            // soft rounded corners
      }}
    >
      Monthly
    </span>{' '}
    follow-up with Dr. Aya Belal via WhatsApp during working hours.
  </span>
</div>
                                </li>
                                
                            </ul>

                            <NavLink
                                to="/membership" className="medium font__size--14 text__14-1024 color__white btn btn__purple shadow w-100 rounded__50">More Details</NavLink>

                        </div>
                    </div>
                    <div className="col-md-6 mb-4 mb-lg-0 col-lg-4">
                        <div className="wrapper__price-list bg__blue">
                            <h4 className="medium font__size--40 text__40-1024 text__40-md text__40-mm mb-3 color__white">EGP1000<sub className="medium font__size--16 text__16-1024 color__gray-3">/<span style={{ textDecoration: 'line-through' }}>2000</span></sub></h4>
                            <p className="medium font__size--20 text__20-1024 color__purple mb-0">GOLDEN</p>

                            <ul className="list__data-detail medium font__size--18 text__18-1024 my-4 color__white">
                                <li>
                                    <div className="d-flex align-items-start">
  <img src="./../images/fsdfdsf.png" className='object-fit-content' alt="" />
  <span className="ml-2">
    <span
      style={{
        backgroundColor: '#FFD700',   // gold highlight
        color: '#000',                 // black text for contrast
        fontWeight: '600',             // bold
        padding: '2px 6px',            // some spacing around the word
        borderRadius: '4px'            // soft rounded corners
      }}
    >
      Weekly
    </span>{' '}
    follow-up with Dr. Aya Belal via WhatsApp during working hours.
  </span>
</div>
                                </li>
                                                            </ul>

                            <NavLink
                                to="/membership" className="medium font__size--14 text__14-1024 color__white btn btn__purple shadow w-100 rounded__50">More Details</NavLink>

                        </div>
                    </div>
                    <div className="col-md-6 mb-4 mb-lg-0 col-lg-4">
                        <div className="wrapper__price-list">
                            <h4 className="medium font__size--40 text__40-1024 text__40-md text__40-mm mb-3">EGP1500<sub className="medium font__size--16 text__16-1024 color__gray-2">    /<span style={{ textDecoration: 'line-through' }}>3000</span>
                            </sub></h4>
                            <p className="medium font__size--20 text__20-1024 color__purple mb-0">PREMIUM</p>

                            <ul className="list__data-detail medium font__size--18 text__18-1024 my-4">
                                <li>
                                <div className="d-flex align-items-start">
  <img src="./../images/asa.png" className='object-fit-content' alt="" />
  <span className="ml-2">
    <span
      style={{
        backgroundColor: '#FFD700',   // gold highlight
        color: '#000',                 // black text for contrast
        fontWeight: '600',             // bold
        padding: '2px 6px',            // some spacing around the word
        borderRadius: '4px'            // soft rounded corners
      }}
    >
      Daily
    </span>{' '}
    follow-up with Dr. Aya Belal via WhatsApp during working hours.
  </span>
</div>
                                </li>
                                                           </ul>

                            <NavLink
                                to="/membership" className="medium font__size--14 text__14-1024 color__white btn btn__purple shadow w-100 rounded__50">More Details</NavLink>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Price